import styled from 'styled-components';

export const Card = styled.div`
  width: 100%;
  background: #ffffff;
  border-radius: 8px;
  display: block;
  padding: 16px;
`;

export const PriceRow = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  color: #161d1f;
  font-family: Lato;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
`;

export const CheckButton = styled.div.attrs((props: any) => ({
  disabled: props.disabled
}))`
  display: flex;
  gap: 4px;
  align-items: start;
  justify-content: center;
  padding: 4px 8px 8px 8px;

  input {
    :hover {
      cursor: ${(props) => (props.disabled ? 'auto' : 'pointer')};
    }
  }
`;

export const FeeFrame = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const FeeDetails = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  align-items: flex-start;
`;

export const FeeTitle = styled.p`
  font-family: Lato;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  color: #161d1f;
`;

export const FeeSubtitle = styled.p`
  font-family: Lato;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  color: #4f6168;
`;

export const FeeTag = styled.div`
  border-radius: 20px;
  padding: 4px 12px;
  font-family: Lato;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  line-height: 16px;
  text-transform: capitalize;
  &.default {
    color: #fddc70;
    background-color: #694900;
  }
  &.expired {
    color: #fdadb3;
    background-color: #890722;
  }
  &.payed {
    color: #a8f1bb;
    background-color: #005c27;
  }
`;

export const FeePrice = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  color: #161d1f;
  font-family: Lato;
  font-size: 14px;
  font-style: normal;
  font-weight: 900;
  line-height: 20px;
  p {
    &.debt {
      color: #e8212b;
    }
  }
`;

export const PaymentButton = styled.button`
  background: #5b36f2;
  border-radius: 4px;
  color: #ffffff;
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  border: none;
  padding: 12px 24px;
  align-self: flex-start;
  margin-top: 20px;

  &:hover {
    background: #745ef6;
  }

  &:focus,
  active {
    background: #4318cd;
  }
`;
